<template>
  <div>
    <div v-for="(item, idx) in items" :key="idx">
      <CustomerPrototypeItem
        :visible="item.flag"
        :expanded="false"
        :key="item.id"
        :id="item.id"
        :isLastScan="lastScan.id === item.id"
        @delete="removeItem"
      >
        <template v-slot:title>
          <b-input-group>
            <!-- <b-form-input
              aria-label="Qty"
              placeholder="Qty"
              class="text-center"
              v-model="item.qty"
              @blur="updateSeal(item.id)"
            ></b-form-input> -->
            <b-form-checkbox
              :id="`checkboxa${item.id}`"
              :name="`checkboxa${item.id}`"
              v-model="item.completed"
            >
            </b-form-checkbox>
            <b-form-input
              aria-label="Type"
              placeholder="Type"
              class="text-center col-5"
              v-model="item.packageType"
            ></b-form-input>
            <b-form-input
              aria-label="Description"
              placeholder="Description"
              class="text-center"
              v-model="item.description"
            ></b-form-input>
          </b-input-group>
        </template>
      </CustomerPrototypeItem>
    </div>
  </div>
</template>

<script>
import CustomerPrototypeItem from './CustomerPrototypeItem.vue';

export default {
  name: 'ClientPrototypeList',
  props: ['items', 'lastScan'],
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
    toggleHazardous(id) {
      this.$emit('toggleHazard', id);
    },
    updateSeal(id) {
      this.$emit('updateSeal', id);
    },
  },
  components: { CustomerPrototypeItem },
};
</script>

<style scoped>

</style>
